export const Name = 'open-product-info-dialog';
export const OpenProductInfoDialogDialog = Name;
export let DialogMode = /*#__PURE__*/function (DialogMode) {
  DialogMode["Favorites"] = "favorites";
  DialogMode["Loading"] = "loading";
  DialogMode["StandardBuy"] = "standardBuy";
  return DialogMode;
}({});
//# sourceMappingURL=event.js.map